import React, { useContext, useState, useEffect } from "react";

import styles from './Header.module.css';
import botonAtras from "../../img/btnflecha-atras.png";
import logoPacifico from "../../img/pacifico-logo-white.png";

//Context
import GeneralContext from "../../context/GeneralContext";
import * as GLOBALES from '../../utils/globales'

const Header = ({ history, valor }) => {
    const initialState = {
        listaMenu: []
    }

    const { state } = useContext(GeneralContext);
    const [ localState, setLocalState ] = useState(initialState)

    let user = state.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]

    useEffect(() => {
        let listaMenu = null
        if(prospecto.cotizaciones !== null && prospecto.cotizaciones !== undefined) {
            prospecto.cotizaciones.map(cotizacion => {
                if(cotizacion.isSelected) {
                    listaMenu = cotizacion.listaMenu
                }
                return cotizacion
            })
        }

        listaMenu = listaMenu !== null ? listaMenu : GLOBALES.LISTA_MENU_INICIAL

        setLocalState((localState) => {
            return {
                listaMenu: listaMenu
            }
        })
    }, [])

    const getUrl = (menu) => {
        let url = null

        if (menu.completado || menu.paginaActual) {
            if (menu.url !== null) {
                url = menu.url
            } else {
                if (menu.listaSubmenu!==undefined && menu.listaSubmenu!==null && 
                    menu.listaSubmenu.length > 0) {
                        menu.listaSubmenu.map((submenu, index) => {
                            if((menu.paginaActual && submenu.paginaActual) || (!menu.paginaActual && index === 0)) {
                                url = submenu.url
                            }
                            return submenu
                        })
                }
            }
        }

        return url
    }

    const getEstilo = (menu, reque) => {
        let estilo = ''
        if(menu.completado && menu.url!==history.location.pathname) {
            if (menu.listaSubmenu!==undefined && menu.listaSubmenu!==null &&
                menu.listaSubmenu.length>0) {
                    if(history.location.pathname !== '/prospectoFinal') {
                        estilo = 'disabled'
                        menu.listaSubmenu.map(submenu => {
                            if (submenu.url === history.location.pathname) {
                                estilo = 'active'
                            }
                            return submenu
                        })
                    } else {
                        estilo = 'disabled2'
                    }
            }
            else {
                if (history.location.pathname === '/prospectoFinal')
                    estilo = 'disabled2'
                else {
                    if (menu.descripcion === 'Requisitos' && !reque)
                        estilo = 'disabled2'
                    else
                        estilo = 'disabled'
                }
            }
        }
        else {
            if (menu.url === history.location.pathname){
                estilo = 'active'
            }
            else {
                if (menu.listaSubmenu!==undefined && menu.listaSubmenu!==null &&
                    menu.listaSubmenu.length>0) {
                        estilo = 'actual'
                        menu.listaSubmenu.map(submenu => {
                            if (submenu.url === history.location.pathname) {
                                estilo = 'active'
                            }
                            return submenu
                        })
                }
                else {
                    estilo = 'actual'
                }
            }
        }

        return estilo
    }

    return (
        <header className={styles['headprospecto']}>
            <div className={styles['headprespecto__grupo']}>
                <div className={styles['headprospecto__data']}>
                    <a href='/home'><img className={styles['fechatras']} src={botonAtras} alt="" /></a>
                    <h1>{prospecto.nombreCompleto} (IDProspecto: {prospecto.idProspecto})</h1>
                </div>
                <div className={styles['headprospecto__logo']}>
                    <img src={logoPacifico} alt="" />
                </div>
            </div>
          
            <nav className={styles['navegacion']}>
                <ul>
                    {localState.listaMenu.map((menu) => (
                        <li key={menu.id}>
                            <a
                                className={styles[getEstilo(menu, valor)]}
                                href={getUrl(menu)}
                            >
                                {menu.descripcion}
                            </a>
                        </li>
                    ))

                    }                    
                </ul>
            </nav>
          
      </header>
    )
}

export default Header;